/**
 * Buno Plus Cart Integration
 * Simplified instance management for buno-plus products
 */

class BunoPlusManager {
  constructor() {
    this.instances = new Map();
    this.isInitialized = false;
    
    this.init();
  }
  
  init() {
    if (this.isInitialized) return;
    
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
    
    this.isInitialized = true;
  }
  
  setupEventListeners() {
    // Listen for buno-plus state changes
    document.addEventListener('buno-plus:state-changed', (event) => {
      this.handleStateChange(event.detail);
    });
    
    // Listen for cart updates to sync state
    document.addEventListener('cart:updated', (event) => {
      this.syncWithCartUpdate(event.detail);
    });
    
    // Listen for cart refresh events (when cart drawer content is replaced)
    document.addEventListener('cart:refresh', () => {
      // Re-initialize after a short delay to allow DOM updates
      setTimeout(() => {
        this.reinitializeInstances();
      }, 300);
    });
  }
  
  registerInstance(sectionId, instance) {
    this.instances.set(sectionId, instance);
  }
  
  handleStateChange(stateData) {
    // Update local state tracking if needed
    // This could be used for analytics or debugging
    console.log('Buno-plus state changed:', stateData);
  }
  
  syncWithCartUpdate(cartData) {
    // Instances handle their own state sync via cart:updated events
    // This method is kept for potential future use
  }
  
  reinitializeInstances() {
    // Clear existing instances since they may be stale after DOM updates
    this.instances.clear();
    
    // Find all buno-plus containers and re-register them
    const containers = document.querySelectorAll('[id^="buno-plus-container-"]');
    containers.forEach(container => {
      const sectionId = container.id.replace('buno-plus-container-', '');
      if (window.BunoPlusManager && window.BunoPlusManager[sectionId]) {
        this.registerInstance(sectionId, window.BunoPlusManager[sectionId]);
      }
    });
  }
  
  // Public API methods
  getAllInstances() {
    return Array.from(this.instances.values());
  }
  
  getInstanceBySectionId(sectionId) {
    return this.instances.get(sectionId);
  }
}

// Initialize global manager
if (!window.bunoPlusManager) {
  window.bunoPlusManager = new BunoPlusManager();
}

// Enhance the global BunoPlusManager object to work with the manager
const originalBunoPlusManager = window.BunoPlusManager || {};
window.BunoPlusManager = new Proxy(originalBunoPlusManager, {
  set(target, property, value) {
    target[property] = value;
    
    // Register new instances with the manager
    if (value && typeof value === 'object' && typeof value.isSelected === 'function') {
      window.bunoPlusManager.registerInstance(property, value);
    }
    
    return true;
  },
  
  get(target, property) {
    return target[property];
  }
});

// Export for potential module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = BunoPlusManager;
}